/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgreementDto } from '../models/agreement-dto';
import { agreementGet } from '../fn/agreement/agreement-get';
import { AgreementGet$Params } from '../fn/agreement/agreement-get';

@Injectable({ providedIn: 'root' })
export class AgreementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `agreementGet()` */
  static readonly AgreementGetPath = '/v1/Agreement/Get';

  /**
   * Get agreement by insurerId & profileId,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the matching agreement
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementGet$Response(params?: AgreementGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgreementDto>> {
    return agreementGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get agreement by insurerId & profileId,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the matching agreement
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementGet(params?: AgreementGet$Params, context?: HttpContext): Observable<AgreementDto> {
    return this.agreementGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgreementDto>): AgreementDto => r.body)
    );
  }

}
